window.picUplBoxReplace = function(org = '.picUplBox_RP'){
	Dropzone.autoDiscover = false;
	var nameEl;
	//var picDropSelHtml = '<div class="pub_add"><div class="drop"><span>Drop image</span></div><div class="or">OR</div><div class="click frBtn"><span>Click here</span></div><input class="fileRemove" type="file" name="files"></div><input type="hidden" class="nval" name="{nameEl}" value=""><div><div class="pch_item_pic"><img src="/img/noimg_th.png" data-dz-thumbnail></div><div class="pch_item_info dz-details"><div class="pch_item_title dz-filename"></div><div class="pch_item_detail dz-size"></div><div class="pch_item_desc"><div class="pub_ldr_progress dz-progress"><div class="bar"></div></div></div></div><div class="options"><a href="#" target="_parent" class="pub_viewBtn"><img src="/img/icons/clr/16/view.png"/></a><a href="#" target="_parent" class="pub_delBtn"><img src="/img/icons/clr/16/delete.png"/></a></div></div>';
	
	
	//var picDropSelHtml = '<div class="picUplBox box_{nameEl}">';
	var picDropSelHtml = '	<div class="pub_add">';
	picDropSelHtml += '		<div class="drop"><span>Drop image</span></div>';
	picDropSelHtml += '			<div class="or">OR</div>';
	picDropSelHtml += '			<div class="click frBtn"><span>Click here</span></div>';
	picDropSelHtml += '			<input class="fileRemove" type="file" name="files">';
	picDropSelHtml += '		</div>';
	picDropSelHtml += '		<div class="pub_loader">';
	picDropSelHtml += '			<div class="pub_ldr_pic"><img src="/img/noimg_th.png"/></div>';
	picDropSelHtml += '			<div class="pub_ldr_info">';
	picDropSelHtml += '				<div class="pub_ldr_title"></div>';
	picDropSelHtml += '				<div class="pub_ldr_detail"></div>';
	picDropSelHtml += '				<div class="pub_ldr_progress"><div class="bar"></div></div>';
	picDropSelHtml += '				<div class="pub_ldr_options">';
	picDropSelHtml += '					<a href="#" target="_parent" class="pub_viewBtn"><img src="/img/icons/clr/16/view.png"/></a>';
	picDropSelHtml += '					<a href="#" class="pub_delBtn" data-delpic="{elDelPic}"><img src="/img/icons/clr/16/delete.png"/></a>';
	picDropSelHtml += '				</div>';
	picDropSelHtml += '			</div>';
	picDropSelHtml += '		</div>';
	picDropSelHtml += '		<input type="hidden" class="nval" name="{nameEl}" value="">';
	//picDropSelHtml += '	</div>';
	
	
	// loop all elements and replace them with 'fancy' picture upload box
	$('.picUplBox_RP').each(function(){
		//alert("picUplBox_RP");
		
		nameEl = $(this).attr("name");
		var dirEl 	= $(this).attr("data-dir");
		var valEl 	= $(this).attr("data-val");
		var delPic 	= $(this).attr("data-delpic");
		
		replaceHtml = picDropSelHtml.replace(/{nameEl}/g, nameEl);
		replaceHtml = replaceHtml.replace(/{elDelPic}/g, delPic);
		replaceHtml = pchItemTemp(replaceHtml, 'picUplBox box_'+ nameEl +' dropzone-previews');
		
		$(this).replaceWith(replaceHtml);

		
		if(valEl != ""){
			$('.box_'+nameEl+' .pub_loader .pub_ldr_pic img').attr("src", dirEl+valEl);
			$('.box_'+nameEl+' .pub_loader .pub_ldr_title').html(imageShortTitle(valEl));
			$('.box_'+nameEl+' .pub_loader .pub_ldr_detail').html("Type: image/"+imageExt(valEl));
			$('.box_'+nameEl+' .pub_loader .pub_ldr_progress').hide();
			$('.box_'+nameEl+' .pub_loader .pub_ldr_options').show();
			$('.box_'+nameEl+' .pub_loader .pub_ldr_options .pub_viewBtn').attr('target', '_blank').attr('href', (dirEl+valEl).replace('th','xl'));

			
			$('.box_'+nameEl+' .pub_add').hide();
			$('.box_'+nameEl+' .pub_loader').show();
		}
		
		
		$('.box_'+nameEl).on('click','.click',function(e){
			e.preventDefault();
			//$('#fileupload').click();
		});
			
		$('.box_'+nameEl).fileupload({
			dataType: 'json',
			url: "/upload", 
			formData: { _token: $('meta[name="csrf-token"]').attr('content') },
			
			maxFiles: 1,
			acceptedFiles: "image/*",
			
			thumbnailWidth: 78,
			thumbnailHeight: 50,
			
			resizeWidth: 1920,
			resizeQuality: 1,

			maxFileSize: 20000000,
			loadImageMaxFileSize : 20000000,

			dropZone: $('.pub_add .drop', this),
			
			// Enable image resizing, except for Android and Opera,
			// which actually support image resizing, but fail to
			// send Blob objects via XHR requests:
			disableImageResize: /Android(?!.*Chrome)|Opera/
				.test(window.navigator && navigator.userAgent),
			imageForceResize: true,
			imageQuality: 1,
			
			previewMaxWidth: 80,
			previewMaxHeight: 52,
			previewCrop: true,

			imageMaxWidth: 1920,
			imageMaxHeight: 1080,
			imageCrop: false,
			
			
			add: function (e, data) {			
				$.blueimp.fileupload.prototype.options.add.call(this, e, data);

				$('.' + e.target.classList[2] + ' .pub_loader .pub_ldr_pic img').attr("src", "/img/noimg_th.png");
				$('.' + e.target.classList[2] + ' .pub_loader .pub_ldr_title').html(imageShortTitle(data.files[0].name));
				$('.' + e.target.classList[2] + ' .pub_loader .pub_ldr_detail').html("Type: "+data.files[0].type+" | Size: "+Math.round(data.files[0].size / 1024)+" kB");
				$('.' + e.target.classList[2] + ' .pub_loader .pub_ldr_pic').html('<img src="/img/noimg_th.png"/>'); // reset if not the first img
				
				$('.' + e.target.classList[2] + ' .pub_add').hide();
				$('.' + e.target.classList[2] + ' .pub_loader').show();				
				$('.' + e.target.classList[2] + ' .pub_loader .pub_ldr_progress ').show();
				
				data.submit();
			},
			done: function (e, data) {
				var file = data.files[0];
				if (file.preview){
					$('.' + e.target.classList[2] + ' .pub_loader .pub_ldr_pic').html(file.preview);
				}
				
				$('.' + e.target.classList[2] + ' .nval').val(data.result.files[0].name);
				$('.' + e.target.classList[2] + ' .pub_ldr_progress ').hide();
				$('.' + e.target.classList[2] + ' .options').show();
				
				var file = data.result.files[0];

				if(file.name){
					$('.' + e.target.classList[2] + ' .pub_loader .pub_ldr_options .pub_viewBtn').attr('target', '_blank').attr('href', "/storage/temp/" + file.name);
				}else if(file.error){
					$('.' + e.target.classList[2] + ' .pub_loader .pub_ldr_title').html(file.error);
				}
			}
		}).on('fileuploadprogress', function (e, data) {
			var perc = Math.ceil(data._progress.loaded / (data._progress.total / 100));
			
			// Maybe display some more file information on your page
			$('.' + e.target.classList[2] + ' .pub_loader .bar').width(perc + "%");
		});
		

		$('.box_'+nameEl).on('click','.pub_delBtn',function(e){
			e.preventDefault();
			var thisError = false;
			var delhref = $(this).attr("data-delpic");
			

			
			if(delhref){
				axios.get(delhref)
					.catch(function (error) {
						if(error.response && (error.response.status === 401 || error.response.status === 419)){
							window.location.href = "/login";
						}else{
							thisError = true;
							var cusalert = new window.cusAlert('Error', 'Could not delete this image.');
							cusalert.open();
						}
					});
			}
			
			if(!thisError){
				
				$('.box_'+nameEl+' .pub_loader .pub_ldr_pic', this).html('<img src="/img/noimg_th.png"/>');
				$('.box_'+nameEl+' .nval').val("");
				$('.box_'+nameEl+' .pub_loader .pub_ldr_pic', this).html('<img src="/img/noimg_th.png"/>');
				$('.box_'+nameEl+' .options').hide();
				$('.box_'+nameEl+' .pub_loader .bar').width("0%");
				
				$('.pub_add').show();
				$('.pub_loader').hide();
			}
		});

	});
	
	

}

function pchItemTemp(hldHtml = "", hldClass = ""){
	var retHtml = '';
	
	retHtml += '<div class="pch_item">';
	retHtml += '	<div class="pch_item_hld '+ hldClass +'">';
	retHtml += 			hldHtml;
	retHtml += '	</div>';
	retHtml += '</div>';
	
	return retHtml;
}

function imageShortTitle(title, max = 16){
	var retString = title;
	if(title.length > max){
		var parts = title.split(".");
		retString = parts[0].substring(0, max)+"..."+parts[1];
	}
	return retString;
}

function imageExt(title){
	var parts = title.split(".");

	return parts[1];
}
